module.exports = __webpack_public_path__ + "static/img/brees-2003-slide-5.3a162fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-slide-5.jpg
// module id = TJud
// module chunks = 1